module.exports = __webpack_public_path__ + "img/79860bc.png";